import { Modal } from '@testsigma/atoms';

import {
  RefreshMetadataSyncStarted,
  RefreshMetadataWarningScreen,
} from '../components/refresh-metadata-modal-screens';

import {
  RefreshModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';
import { StandardObjectsSyncedScreen } from '../components/refresh-metadata-modal-screens/standard-objects-synced-screen';
const RefreshMetadataModal: React.FC = () => {
  const { overlayMode, handleUpdateOverlayMode, refreshModalScreen } =
    useSFConnectionState();

  if (overlayMode !== 'refresh_metadata_screen') {
    return null;
  }

  const handleClose = () => {
    handleUpdateOverlayMode('none');
  };

  return (
    <Modal
      isOpen={overlayMode === 'refresh_metadata_screen'}
      showCloseButton={true}
      closeOnEscape={true}
      closeOnOutsideClick={true}
      className='!rounded-lg !w-[450px] !py-10 !px-6  relative'
      onClose={handleClose}
    >
      {refreshModalScreen === RefreshModalScreens.SYNC_ALREADY_TRIGGERED && (
        <RefreshMetadataWarningScreen />
      )}

      {refreshModalScreen === RefreshModalScreens.SYNC_TRIGGERED && (
        <RefreshMetadataSyncStarted />
      )}

      {refreshModalScreen === RefreshModalScreens.SYNC_PARTIALLY_TRIGGERED && (
        <StandardObjectsSyncedScreen />
      )}
    </Modal>
  );
};

export { RefreshMetadataModal };
